export default __webpack_public_path__ + "static/media/logout.c7c421c6.png";